var Handlebars = require('/var/lib/jenkins/jobs/wunderman_resolution/workspace/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(container.lambda((depth0 != null ? depth0.template : depth0), depth0))
    + ",";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "		<div id=\"popup-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" class=\"site-popup "
    + alias2(alias1((depth0 != null ? depth0.classes : depth0), depth0))
    + "\">\n			"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.close_src : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n			"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.html : stack1), depth0)) != null ? stack1 : "")
    + "\n		</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "<img class=\"popup-close\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.close_src : depth0), depth0))
    + "\">";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	<script id=\"template-"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.template : depth0), depth0))
    + "\" type=\"text/x-handlebars-template\">\n"
    + ((stack1 = container.invokePartial(helpers.lookup.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"template",{"name":"lookup","hash":{},"data":data}),(depth0 != null ? depth0.data : depth0),{"data":data,"indent":"\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	</script>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = container.invokePartial(partials.header,(depth0 != null ? depth0.header : depth0),{"name":"header","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<input type=\"hidden\" id=\"validTemplates\" name=\"\" value=\""
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.pages : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n<main role=\"main\" class=\"site-content\">\n\n\n</main>\n\n<div id=\"popup-overlay\" class=\"popup-overlay\">\n	<div class=\"popups-wrapper\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.popups : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</div>\n</div>\n\n\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.pages : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(partials.footer,(depth0 != null ? depth0.footer : depth0),{"name":"footer","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/template.hbs
// module id = 35
// module chunks = 0